module.exports = __webpack_public_path__ + "img/ajhm.67070be0.jpg";